/* @flow */
/* eslint-disable graphql/template-strings */
import gql from 'graphql-tag';

export const GET_REACTION_SUMMARY = gql`
  query GetStreamItemReaction($messageUuid: String!) {
    reactionSummary(messageUuid: $messageUuid) {
      messageUuid
      version
      reactions {
        name
        count
        hasReacted
        users {
          uuid
          name
          color
          initials
        }
      }
    }
  }
`;

export const REMOVE_REACTION_FROM_SUMMARY = gql`
  mutation removeReaction(
    $chatUuid: String!
    $messageUuid: String!
    $name: String!
    $chatMessageReactionToken: String
  ) {
    removeReaction(
      input: {
        name: $name
        chatUuid: $chatUuid
        messageUuid: $messageUuid
        chatMessageReactionToken: $chatMessageReactionToken
      }
    ) {
      reactionSummary {
        messageUuid
        version
        reactions {
          name
          count
          hasReacted
          users {
            uuid
            name
            color
            initials
          }
        }
      }
      error {
        message
      }
    }
  }
`;

export const ADD_REACTION_TO_SUMMARY = gql`
  mutation addReaction(
    $chatUuid: String!
    $messageUuid: String!
    $name: String!
    $chatMessageReactionToken: String
  ) {
    addReaction(
      input: {
        name: $name
        chatUuid: $chatUuid
        messageUuid: $messageUuid
        chatMessageReactionToken: $chatMessageReactionToken
      }
    ) {
      reactionSummary {
        messageUuid
        version
        reactions {
          name
          count
          hasReacted
          users {
            uuid
            name
            color
            initials
          }
        }
      }
      error {
        message
      }
    }
  }
`;
